// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../core/flex-dashboard';
import NetworkDetail from '../search-data/network-detail';
import Networks from '../search-data/networks';
import CreateNetwork from '../app/create-network';
import EditNetwork from '../app/edit-network';
import EditNetworkImage from '../app/edit-network-image';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Network Detail',
                                component: NetworkDetail,
                            },
                        ],
                    },
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Networks',
                                component: Networks,
                                config: {
                                    componentProps: {
                                        detailLink: '/networks',
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Create Network',
                        component: CreateNetwork,
                    },
                    {
                        type: 'tab',
                        name: 'Edit Network',
                        component: EditNetwork,
                    },
                    {
                        type: 'tab',
                        name: 'Edit Network Image',
                        component: EditNetworkImage,
                    },
                ],
            },
        ],
    },
};

function DashboardNetworks() {
    return <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="networks" />;
}

export default DashboardNetworks;
